import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import ShareSpaceItemRecord from "models/view-models/share-spaces/share-space-item-record";

export interface ShareSpaceItemResourcePathParams {
    shareSpaceId: number;
}

interface ShareSpaceItemListQueryParams {}

const baseEndpoint = "sharespaces/:shareSpaceId/sharespaceitems";
const resourceEndpoint = `${baseEndpoint}/:shareSpaceItemId`;
const resourceType = ShareSpaceItemRecord;

const ShareSpaceItemService = {
    create: ServiceFactory.nestedCreate<
        ShareSpaceItemRecord,
        ShareSpaceItemResourcePathParams
    >(resourceType, baseEndpoint),
    list: ServiceFactory.nestedList<
        ShareSpaceItemRecord,
        ShareSpaceItemListQueryParams,
        ShareSpaceItemRecord
    >(resourceType, baseEndpoint),
    bulkUpdate: ServiceFactory.bulkUpdate<
        ShareSpaceItemRecord,
        ShareSpaceItemResourcePathParams
    >(ShareSpaceItemRecord, baseEndpoint),
    delete: ServiceFactory.delete(resourceEndpoint),
    useDeleteAll: ServiceHookFactory.useDelete(baseEndpoint),
};

export default ShareSpaceItemService;
